import { gql } from '@apollo/client';

export const PUBLISH_POST_REPLY = gql`
    mutation publishPostReply($input: PostReplyInput) {
        publishPostReply(input: $input) {
            id
            status
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            author {
                userId
                username
            }
            postAnalytics {
                id
                author {
                    userId
                    username
                }
                metrics {
                    replies
                    votes {
                        upVotes
                        downVotes
                    }
                    hidden
                    reportedPost {
                        reportedTimes
                        causes
                    }
                    votesCount {
                        upVotes
                        downVotes
                    }
                    replyCount
                    repostCount
                    bookmarkCount
                }
            }
            createdAt
            updatedAt
            viewerInteractions {
                hasLiked
                hasReposted
                hasBookmarked
            }
            feedMetadata {
                entryType
                reason
                mutualUsers {
                    id
                    username
                }
            }
            parentPostId
        }
    }
`;
